/*
 * Copyright (c) 2019
 *    Reliant Business Valuation, LLC - http://reliantvalue.com
 *    Author: Xaero Zero - xaerozero@icloud.com
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import {Injectable, EventEmitter} from '@angular/core';

@Injectable()
export class AclActionService {
  onCreateNew: EventEmitter<void> = new EventEmitter();
  onSearch: EventEmitter<string> = new EventEmitter();

  onCreateNewRole: EventEmitter<void> = new EventEmitter();
  onSearchRole: EventEmitter<string> = new EventEmitter();

  onCreatePrivilege: EventEmitter<void> = new EventEmitter();
  onSearchPrivilege: EventEmitter<string> = new EventEmitter();

  onCreateNewPosition: EventEmitter<void> = new EventEmitter();
  onSearchPosition: EventEmitter<string> = new EventEmitter();
}
